import React from 'react';
import { call } from 'redux-saga/effects';
import { IWorkbookActions } from '~src/ts/ServerApi/types/IWorkbookActions';

import { getWorkbookInfos } from '~src/app/sagas/spaces/SpacesSagaHelpers';
import { WorkbookCard } from '~src/app/spaces/CardView/WorkbookCard';
import { getAngularWorkbookDetailDialogOptions } from '~src/app/spaces/DetailsDialog/AngularContentDetailsDialogOptions';
import { SpacesSiteUrls } from '~src/app/spaces/SpacesSiteUrls';
import { ConnectedWorkbookDetailsDialogBody } from '~src/app/spaces/WorkbookSpace/WorkbookDetailsDialog';
import { Messages } from '~src/codegen/Localize';
import { imgPath } from '~src/common/utilities/ImgUrl';
import { Workbooks } from '~src/content/resources/Workbooks';
import { ContentTypeFilterClause, MixedContentItemDefinition, SpaceDefinition } from '~src/contentDefinitionInterfaces/ContentDefinitionsTypes';
import { ServerFilterClauses } from '~src/ts/helpers/ServerFilterClauses';
import { WorkbookContentType } from '~src/ts/models/ContentTypes';
import { IContentInfo } from '~src/ts/models/IContentInfo';
import { IWorkbookDetailInfoWithUsage } from '~src/ts/models/IWorkbookInfo';

import { getGenericDefaultFilters } from './getDefaultFilters';

export const WorkbookDefinition: MixedContentItemDefinition & SpaceDefinition<'workbook'> = {
  itemType: 'workbook',
  contentType: 'workbook',
  singularName: Messages.workbook,
  pluralName: Messages.workbooks,
  emptyStateMessage: Messages.workbooksEmptyMessage,
  siteFilterByTypeDropdownName: Messages.siteFilterByTypeDropdown_Workbooks,
  contentFilterKeys: WorkbookContentType.filterKeys,
  defaultFilters: getGenericDefaultFilters,
  cardComponent: WorkbookCard,
  listViewIconUrl: imgPath('workbook_18px-large.svg'),
  filterClause: ServerFilterClauses.ContentType(['workbook']) as ContentTypeFilterClause,
  contentSpaceUrl: (urls: SpacesSiteUrls, contentId: string) => urls.workbookUrl(contentId),
  getBasicQuery: () => {
    return Workbooks.all().withExtraParams(WorkbookContentType.extraQueryParams);
  },
  fieldValueResourceType: 'workbook',
  getDetailsDialogOptions: getAngularWorkbookDetailDialogOptions,
  getContentInfo: (contentList: IContentInfo[]) => call(getWorkbookInfos, contentList),
  headerIconPath: () => imgPath('spaces_masthead_workbook.svg'),
  supportedDisplayModes: ['list', 'thumbnail'],
  detailDialogTitle: Messages.workbookDetailsTitle,
  detailDialogBody: (content: IContentInfo<'workbook'>, availableActions: IWorkbookActions) => {
    return (
      <ConnectedWorkbookDetailsDialogBody
        workbook={content as IWorkbookDetailInfoWithUsage}
        allowedActions={availableActions}
      />
    );
  },
};
